exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".expand-enter-active[data-v-0dbef608],.expand-leave-active[data-v-0dbef608]{transition:height .3s ease-in-out,opacity .3s ease-in-out;transition-property:opacity,height;overflow:hidden}.expand-enter[data-v-0dbef608],.expand-leave-to[data-v-0dbef608]{height:0;opacity:0}", ""]);

// exports
